import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categoryList } from '@/mocks/common';

const categoryIcons: Record<string, string> = {
  '热门精选': 'ri-fire-line',
  '最新上线': 'ri-timer-line',
  '电影大片': 'ri-movie-2-line',
  '电视剧集': 'ri-tv-2-line',
  '综艺娱乐': 'ri-live-line',
  '动漫动画': 'ri-ancient-gate-line',
  '纪录片': 'ri-camera-lens-line',
  '短视频': 'ri-smartphone-line',
};

const categoryDescriptions: Record<string, string> = {
  '热门精选': '全网最热门的视频内容汇聚于此，每日实时更新热门榜单',
  '最新上线': '最新上线的视频内容实时更新，不错过每一部新作',
  '电影大片': '海量高清电影片库，涵盖动作、喜剧、爱情、科幻等全类型',
  '电视剧集': '热门电视剧全集收录，国产剧、韩剧、美剧、日剧一应俱全',
  '综艺娱乐': '热门综艺节目实时更新，音乐、真人秀、脱口秀精彩不间断',
  '动漫动画': '热血、搞笑、治愈、悬疑各类动漫一网打尽，日漫国漫全收录',
  '纪录片': '精选全球优质纪录片，涵盖自然、历史、人文、科技等多个领域',
  '短视频': '精选优质短视频内容，搞笑段子、生活妙招、知识科普每日更新',
};

export default function CategoryPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '视频分类 - 91在线视频',
            description: '浏览91在线视频全部内容分类，包括热门精选、电影大片、电视剧集、综艺娱乐、动漫动画、纪录片、短视频等。',
            url: 'https://www.91zaixianshipin.com/category',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.91zaixianshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '视频分类',
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <Link to="/" className="hover:text-accent-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">视频分类</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              视频分类
            </h1>
            <p className="text-foreground-500 max-w-[600px]">
              探索丰富多彩的视频内容，按分类快速找到你想看的内容。涵盖电影、剧集、综艺、动漫等全品类。
            </p>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {categoryList.map((cat) => (
              <Link
                key={cat.label}
                to={cat.href}
                className="group flex flex-col items-center p-6 md:p-8 rounded-2xl bg-background-50 hover:bg-primary-50 transition-all duration-300 border border-background-200/70 hover:border-primary-200 cursor-pointer text-center"
              >
                <div className="w-16 h-16 bg-accent-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-all duration-300">
                  <i className={`${categoryIcons[cat.label] || 'ri-folder-line'} text-2xl text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.label}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {categoryDescriptions[cat.label] || '探索精彩视频内容'}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}